import { RecalculatePriceStrategy } from '../types';
import {
  noOpQuantityChange,
  noOpQuotePriceCreation,
  noOpUnitPrice,
} from './no-op';

export const recalculateUserPrice = {
  onQuantityChange: noOpQuantityChange,
  onUnitPriceChange: noOpUnitPrice,
  onGrossMarginChange: null,
  onBaseGrossMarginChange: null,
  onContributionMarginChange: null,
  onQuotePriceCreation: noOpQuotePriceCreation,
  onUnitCostChange: null,
} satisfies RecalculatePriceStrategy;
